module.exports = __webpack_public_path__ + "img/3_47.4fe3b769.png";